module.exports = __webpack_public_path__ + "static/p03_back-cbab529374d3cf39835787abc25d513a.jpg";